// Import Styles
import '../sass/styles.scss';

// Import Plugins
import 'bootstrap';

import './slider/reviews';

(function () { 

    $(document).ready(function() 
    {
        // Hamburger Menu
        $('.hamburger').on('click', function(e) 
        {
            e.preventDefault();

            $(this).toggleClass('is-active');
            $('.js-header__navigation').toggleClass('is-active');
        });

        // Double Tap to Go
        if (window.matchMedia('(max-width: 991px)').matches) {
            var previousTarget = null;

            $('.menu-item-has-children > a').on('click', function(e) 
            {
                $('.sub-menu').removeClass('js-open');

                if (this === previousTarget) {
                    // Do nothing...
                } else {
                    e.preventDefault();
                    previousTarget = this;
                }

                $(this).next('.sub-menu').toggleClass('js-open');
            });
        }
    });

    $(window).scroll(function() 
    {
        
    });

})();